import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './routes';
import * as serviceWorker from './serviceWorker';

// REDUX
import { Provider } from 'react-redux';
import store from './redux/store';

require("./css/variables.css");
const common = require('./components/common/common');

ReactDOM.render(
  <Provider store={store}>
    <AppRouter />
  </Provider>,
  document.getElementById('app')
);

var iframe_auto_resize = common.getParam("iframe_auto_resize");
common.remove_localStorage("iframe_auto_resize");
if(iframe_auto_resize !== undefined && iframe_auto_resize !== null && iframe_auto_resize)
  common.set_localStorage("iframe_auto_resize", true);

if (window.parent !== window && iframe_auto_resize) {
  const rootElement = document.getElementById('app');

  if (rootElement) {
    // 1. INIEZIONE CSS ANTI-LOOP
    // Creiamo uno stile che forza il contenitore a stringersi attorno al contenuto reale,
    // annullando l'effetto elastico dei 100vh o 100%.
    const style = document.createElement('style');
    style.innerHTML = `
      html, body {
        height: auto !important;
        min-height: 0 !important;
        overflow: hidden !important;
      }
      #app {
        /* fit-content ordina al div di essere alto ESATTAMENTE quanto i suoi figli, ignorando lo schermo */
        height: fit-content !important; 
        min-height: 0 !important;
        /* Se hai div interni con 100vh, questo li neutralizza */
        max-height: none !important; 
      }
      #footer{
        display: none
      }
    `;
    document.head.appendChild(style);

    let timeoutId;
    const resizeObserver = new ResizeObserver(() => {
      clearTimeout(timeoutId);
      
      timeoutId = setTimeout(() => {
        // Calcoliamo l'ingombro reale del contenitore che ora è stretto attorno al contenuto
        const realHeight = rootElement.offsetHeight;
        /*if(realHeight >1500)
          return ;*/
        console.log("📏 [PSC] Calcolo definitivo inviato:", realHeight);
        window.parent.postMessage({ type: 'PSC_RESIZE', height: realHeight }, '*');
      }, 0);
    });

    resizeObserver.observe(rootElement);
  }
}
// -----------------------------------------------------------

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();